
document.addEventListener("DOMContentLoaded", function () {
if(document.querySelector('body.template-collection')){
  const productGrid = document.querySelector(".product-grid");
  if (!productGrid) return;

  const productCards = productGrid.querySelectorAll(
    ".product-card, .card, [data-product-card], .grid__item"
  );

  productCards.forEach(function (card) {
    // Get product name
    const productName =
      card.querySelector(
        ".product-card__title, .card__heading, .product-title, a[href*='/products/']"
      )?.innerText?.trim() || "Unknown product";

    // Check if swatches exist
    const hasSwatches = !!card.querySelector(`
      input[type="radio"][name*="option"],
      input[type="radio"][data-swatch],
      button[data-swatch],
      button[data-value],
      .swatch,
      .swatches,
      .variant-swatch,
      .variant-swatches,
      [data-swatches],
      [data-variant-picker]
    `);

    if (!hasSwatches) return;

    // Show variant container
    const variantBlock = card.querySelector(".collection_set_variant");
    if (variantBlock) {
      variantBlock.style.display = "block";
    }

    // Get first color name from aria-label
    const firstAriaInput = card.querySelector(
      "swatches-variant-picker-component overflow-list li input[aria-label]"
    );

    if (!firstAriaInput) return;

    const colorName = firstAriaInput.getAttribute("aria-label")?.trim();
    if (!colorName) return;

    // ✅ Replace ALL h5 text inside .collection_set_variant
    if (variantBlock) {
      
      card.querySelector(".collection_set_variant h5").innerText = colorName
    }

    console.log(`🎨 ${productName} → color set to: ${colorName}`);
  });
}
});




document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('body.template-collection')){
  const productGrid = document.querySelector(".product-grid");
  if (!productGrid) return;

  // Helper: set the h5 text inside THIS product card only
  function setCardColorName(card, colorName) {
    if (!colorName) return;

    const variantBlock = card.querySelector(".collection_set_variant");
    if (!variantBlock) return;

    // Ensure visible (optional, keep if you want it shown)
    variantBlock.style.display = "block";

    const h5 = variantBlock.querySelector("h5");
    if(colorName!='Show all options'){
    if (h5) h5.textContent = colorName;
    }
  }

  // Helper: pull color name from clicked element or related input
  function getColorNameFromTarget(target, card) {
    // If they clicked the input directly
    if (target.matches('input[aria-label]')) {
      return target.getAttribute("aria-label")?.trim();
    }

    // If they clicked a label, resolve to its input via "for"
    if (target.matches("label[for]")) {
      const forId = target.getAttribute("for");
      const input = forId ? card.querySelector("#" + CSS.escape(forId)) : null;
      return input?.getAttribute("aria-label")?.trim();
    }

    // If they clicked inside a label (like span inside label)
    const parentLabel = target.closest("label[for]");
    if (parentLabel) {
      const forId = parentLabel.getAttribute("for");
      const input = forId ? card.querySelector("#" + CSS.escape(forId)) : null;
      return input?.getAttribute("aria-label")?.trim();
    }

    // If they clicked a button swatch (fallback)
    if (target.matches("button[aria-label]")) {
      return target.getAttribute("aria-label")?.trim();
    }
    const parentBtn = target.closest("button[aria-label]");
    if (parentBtn) {
      return parentBtn.getAttribute("aria-label")?.trim();
    }

    return "";
  }

  // ✅ Event delegation: one listener for the whole grid
  productGrid.addEventListener("click", function (e) {
    // Only react if the click happened inside the swatch component
    const swatchComponent = e.target.closest("swatches-variant-picker-component");
    if (!swatchComponent) return;

    // Find the product card for THIS click
    const card = e.target.closest(".grid__item, .product-card, .card, [data-product-card]");
    if (!card) return;

    // Get color name from aria-label on the related input
    const colorName = getColorNameFromTarget(e.target, card);
    if (!colorName) return;

    // Update only this product’s h5
    setCardColorName(card, colorName);

    // Optional log
    // console.log("🎨 Clicked swatch color:", colorName);
  });

  // ✅ Also update when swatch changes via keyboard/change event
  productGrid.addEventListener("change", function (e) {
    const swatchComponent = e.target.closest("swatches-variant-picker-component");
    if (!swatchComponent) return;

    const card = e.target.closest(".grid__item, .product-card, .card, [data-product-card]");
    if (!card) return;

    if (!e.target.matches('input[aria-label]')) return;

    const colorName = e.target.getAttribute("aria-label")?.trim();
    if (!colorName) return;

    setCardColorName(card, colorName);
  });
}
});
